import { TravelerProfileSuggestionsValidationStep } from '@marageti/z4-sdk/lib/people';
import { SuggestionLocator, SuggestionsState } from './types';

export const START_REVIEW_BEGIN = 'START_REVIEW_BEGIN';
export const START_REVIEW_SUCCESS = 'START_REVIEW_SUCCESS';
export const START_REVIEW_NO_RESULTS = 'START_REVIEW_NO_RESULTS';
export const START_REVIEW_ERROR = 'START_REVIEW_ERROR';
export const RESET_REVIEW = 'RESET_REVIEW';
export const APPLY = 'APPLY';
export const UNAPPLY = 'UNAPPLY';
export const DISMISS = 'DISMISS';
export const UNDISMISS = 'UNDISMISS';
export const APPLY_ALL = 'APPLY_ALL';
export const SKIP_ENTRY_FOR_SESSION = 'SKIP_ENTRY_FOR_SESSION';
export const REQUEST_DISMISS_ALL = 'REQUEST_DISMISS_ALL';
export const CANCEL_DISMISS_ALL = 'CANCEL_DISMISS_ALL';
export const CONFIRM_DISMISS_ALL = 'CONFIRM_DISMISS_ALL';
export const DISMISS_NO_RESULTS_ALERT = 'DISMISS_NO_RESULTS_ALERT';
export const RESET_FOR_TRAVELER = 'RESET_FOR_TRAVELER';

/**
 * Strict discriminated union of every action the suggestions reducer
 * understands. The codebase's other reducers use the loose `Actions`
 * shape from `store/types.ts`; this feature opts into a precise union
 * because the action set is closed and the payloads are non-trivial,
 * which catches typos and missing fields at compile time.
 */
export type Action =
  | { type: typeof START_REVIEW_BEGIN }
  | {
    type: typeof START_REVIEW_SUCCESS;
    suggestions: SuggestionsState;
    validation: TravelerProfileSuggestionsValidationStep | undefined;
  }
  | { type: typeof START_REVIEW_NO_RESULTS }
  | { type: typeof START_REVIEW_ERROR }
  | { type: typeof RESET_REVIEW }
  | { type: typeof APPLY; locator: SuggestionLocator }
  | { type: typeof UNAPPLY; locator: SuggestionLocator }
  | { type: typeof DISMISS; locator: SuggestionLocator }
  | { type: typeof UNDISMISS; locator: SuggestionLocator }
  | { type: typeof APPLY_ALL; suggestions: SuggestionsState }
  | { type: typeof SKIP_ENTRY_FOR_SESSION }
  | { type: typeof REQUEST_DISMISS_ALL }
  | { type: typeof CANCEL_DISMISS_ALL }
  | { type: typeof CONFIRM_DISMISS_ALL }
  | { type: typeof DISMISS_NO_RESULTS_ALERT }
  | { type: typeof RESET_FOR_TRAVELER };

export const startReviewBegin = (): Action => ({ type: START_REVIEW_BEGIN });

export const startReviewSuccess = (
  suggestions: SuggestionsState,
  validation: TravelerProfileSuggestionsValidationStep | undefined,
): Action => ({ type: START_REVIEW_SUCCESS, suggestions, validation });

export const startReviewNoResults = (): Action => ({ type: START_REVIEW_NO_RESULTS });

export const startReviewError = (): Action => ({ type: START_REVIEW_ERROR });

export const resetReview = (): Action => ({ type: RESET_REVIEW });

export const apply = (locator: SuggestionLocator): Action => ({ type: APPLY, locator });
export const unapply = (locator: SuggestionLocator): Action => ({ type: UNAPPLY, locator });
export const dismiss = (locator: SuggestionLocator): Action => ({ type: DISMISS, locator });
export const undismiss = (locator: SuggestionLocator): Action => ({ type: UNDISMISS, locator });

export const applyAll = (suggestions: SuggestionsState): Action => ({ type: APPLY_ALL, suggestions });

export const skipEntryForSession = (): Action => ({ type: SKIP_ENTRY_FOR_SESSION });

export const requestDismissAll = (): Action => ({ type: REQUEST_DISMISS_ALL });
export const cancelDismissAll = (): Action => ({ type: CANCEL_DISMISS_ALL });
export const confirmDismissAll = (): Action => ({ type: CONFIRM_DISMISS_ALL });

export const dismissNoResultsAlert = (): Action => ({ type: DISMISS_NO_RESULTS_ALERT });

export const resetForTraveler = (): Action => ({ type: RESET_FOR_TRAVELER });
